import * as HttpService from "../../../../service/HttpService";

/** 基准曲线  初始化表格  */
export const findLiving = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/findLiving", params);
};

/** 新增运动员  居家离家得配置  批量  */
export const addLiving = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/addLiving", params);
};

/**  删除运动员得配置 */
export const deleteConfig = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/deleteConfig", params);
};

/**根据选择的区域 查找用户  */
export const getCustByRegion = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/getCustByRegion", params);
};
/**根据选择的用户 查找运动员  */
export const getSnsUserByUser = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/getSnsUserByUser", params);
};



/** top 上的查询 list  初始化得时候执行 */
export const getUserAll = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/living/getUserAll", params);
};














